import { Endpoint } from "shared/utils/endpoints";
import { HTTP_CLIENT } from "shared/utils/interceptor";

const GetNotificationsService = (payload: { pageNo: number }) => {
  return HTTP_CLIENT.get(
    Endpoint.notifications.get + `?pageNo=${payload?.pageNo}`
  );
};

const ReadAllNotificationsService = () => {
  return HTTP_CLIENT.post(Endpoint.notifications.readAll);
};

const GetNotificationsCountService = () => {
  return HTTP_CLIENT.get(Endpoint.notifications.count);
};

export {
  ReadAllNotificationsService,
  GetNotificationsService,
  GetNotificationsCountService,
};
